import { useState } from "react";

export const PostsTabs = ({ updateFilterQuery }: { updateFilterQuery: (param: boolean) => void }) => {
  const [activeTab, setActiveTab] = useState<"published" | "scheduled">("published");

  const handleClick = (tab: "published" | "scheduled") => {
    setActiveTab(tab);
    updateFilterQuery(tab === "scheduled");
  };

  return (
    <div className="w-full border-b border-gray-200">
      <nav className="-mb-px flex justify-center space-x-8">
        {/* Published */}
        <button
          onClick={() => handleClick("published")}
          className={`py-2 px-1 border-b-2 font-medium text-lg transition-all
            ${
              activeTab === "published"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 cursor-pointer"
            }`}
        >
          Published Posts
        </button>

        {/* Scheduled */}
        <button
          onClick={() => handleClick("scheduled")}
          className={`py-2 px-1 border-b-2 font-medium text-lg transition-all
            ${
              activeTab === "scheduled"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 cursor-pointer"
            }`}
        >
          Scheduled Posts
        </button>
      </nav>
    </div>
  );
};
